export enum FieldPermission {
  None = -1,
  Read = 0,
  Write = 1,
  Mandatory = 2
}
